var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermsIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8662 8.51562C17.1944 8.51562 14.8148 11.1181 11.9997 12.0651C10.8556 12.4516 10.2823 12.6435 10.0517 12.9154C9.81977 13.1859 9.75148 13.584 9.6162 14.3777C8.16422 22.8757 11.3375 30.7322 18.904 33.7908C19.717 34.1193 20.1241 34.2829 20.8701 34.2829C21.616 34.2829 22.0244 34.1193 22.8374 33.7908C30.404 30.7322 33.5733 22.8757 32.1214 14.3777C31.9848 13.584 31.9178 13.1872 31.6859 12.9154C31.454 12.6435 30.8819 12.4516 29.7379 12.0651C26.9215 11.1181 24.538 8.51562 20.8662 8.51562Z",
    stroke: "#8DC63F",
    strokeWidth: 1.93255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6574 21.6222C22.0166 22.9814 23.8074 24.3625 23.8074 24.3625L26.2618 21.9082C26.2618 21.9082 24.8807 20.1174 23.5214 18.7581C22.1622 17.3989 20.3714 16.0178 20.3714 16.0178L17.917 18.4721C17.917 18.4721 19.2982 20.2629 20.6574 21.6222ZM20.6574 21.6222L16.3633 25.9163M26.6702 21.4985L23.3977 24.7709M20.7824 15.6094L17.5099 18.8818",
    stroke: "#8DC63F",
    strokeWidth: 1.93255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsIcons);
export default __webpack_public_path__ + "static/media/terms-icons.b970ce73877495b5148cd718753654c0.svg";
export { ForwardRef as ReactComponent };